import { DialogTitle, DialogContent } from '@mui/material';
import WaiverForm from './WaiverForm';

export default function WaiverStep() {
    return (
        <>
            <DialogTitle>Waiver</DialogTitle>
            <DialogContent sx={{ paddingX: 4 }}>
                <WaiverForm editable />
            </DialogContent>
        </>
    );
}
